import * as Sentry from "@sentry/react";

export const initSentry = () => {
  console.log("DSN:", process.env.REACT_APP_SENTRY_DSN); // ← add here
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.NODE_ENV,
      tracesSampleRate: 0.2,
    });
  }
};



// utils/sentry.ts
export const captureError = (error: unknown, context?: Record<string, any>) => {
  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext("error_context", context);
      Object.entries(context).forEach(([key, val]) => {
        if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") {
          scope.setTag(key, String(val));
        }
      });
    }

    // KEY FIX: never rewrap — pass original error if it's already an Error
    // Only construct a new Error for plain objects/strings
    if (error instanceof Error) {
      Sentry.captureException(error);
    } else {
      Sentry.captureException(
        new Error(
          typeof (error as any)?.message === "string"
            ? (error as any).message
            : JSON.stringify(error) ?? "Unknown error"
        )
      );
    }
  });
};